
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function MethodSelection({ value, handleChange }) {
  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 150 }}>
    <InputLabel id="demo-simple-select-standard-label">Adjusted Value</InputLabel>
    <Select
      labelId="demo-simple-select-standard-label"
      id="demo-simple-select-standard"
      value={value}
      onChange={handleChange}
    >
      <MenuItem value={"AUTO"}>Automatic</MenuItem>
      <MenuItem value={"MANUAL"}>Manual</MenuItem>
    </Select>
    </FormControl>
  );
}